import './SearchBar.css';

import type { ComponentProps, FunctionComponent } from 'react';

import { MagnifyingGlass } from '../Icons';

type SearchBarProps = ComponentProps<'input'>;

const ICON_SIZE = 24;

export const SearchBar: FunctionComponent<SearchBarProps> = ({ ...props }) => {
  return (
    <div className="search-bar-container">
      <MagnifyingGlass size={ICON_SIZE} />
      <input className="text-sm regular search-bar" {...props} />
    </div>
  );
};
